import PaginationButtonRow from '@shared/components/core/button/PaginationButtonRow';
import { ButtonRowCenter } from '@shared/components/core/card/CommonCardStyles';
import SubSectionRow from '@shared/components/core/headers/SubSectionRow';
import SearchField from '@shared/components/core/search/SearchField';
import { StickyFooterStretch } from '@shared/components/core/structure/CommonBodyLayoutStyles';
import SplashLoader from '@shared/components/loading/SplashLoader';
import { useManagedOrgsFetching } from '@shared/hooks/useManagedOrgsFetching';
import useManagedOrgsSearch from '@shared/hooks/useManagedOrgsSearch';
import { useTranslation } from 'react-i18next';
import LicenseKeySelectAccess from '../licenseKey/LicenseKeySelectAccess';
import ManagedOrgActionRow from './ManagedOrgActionRow';
import ManagedOrgEmptyBanner from './ManagedOrgEmptyBanner';

export default function ManagedOrgPageContent() {
    const { t } = useTranslation();
    const { isLoading } = useManagedOrgsFetching(); //initialize
    const managedOrgSearch = useManagedOrgsSearch(); //search
    const hasResults = managedOrgSearch.results.length > 0;

    if (isLoading) return <SplashLoader />;
    return (
        <>
            <SearchField
                value={managedOrgSearch.searchQuery}
                onChange={(e) => managedOrgSearch.handleSearchQueryChange(e.target.value)}
                onClear={() => managedOrgSearch.handleSearchQueryChange('')}
            />
            {hasResults && <SubSectionRow title={t('common:results')} variant="small"></SubSectionRow>}
            {hasResults ? (
                <>
                    {managedOrgSearch.results.map((managedOrg) => (
                        <ManagedOrgActionRow organization={managedOrg} key={managedOrg.id} />
                    ))}
                    <ButtonRowCenter>
                        <LicenseKeySelectAccess />
                    </ButtonRowCenter>
                </>
            ) : (
                <ManagedOrgEmptyBanner />
            )}

            <StickyFooterStretch $visuallyHide={managedOrgSearch.results.length == 0}>
                <PaginationButtonRow
                    onNext={managedOrgSearch.handleNext}
                    onPrevious={managedOrgSearch.handlePrevious}
                    disableNext={!managedOrgSearch.showNext}
                    disablePrevious={!managedOrgSearch.showPrevious}
                />
            </StickyFooterStretch>
        </>
    );
}
